const assets = {
  images: {
    logo: require("./images/ULTRA_LOGO.png")
  }
};

export default assets;